import { Link, useNavigate } from 'react-router-dom'
import { Col, Form, FormGroup, Input, Label, Row } from 'reactstrap'
import { URL_API } from '../../../utils/helper/helpers'
import { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Btn } from '../../../AbstractElements';
import { useAppDispatch, useAppSelector } from '../../../ReduxToolkit/Hooks';
import { clearCart } from '../../../ReduxToolkit/Reducers/CartSlice';
import { AffecterUneCommadeAUnClient, DispatchementDeProquit } from '../../../utils/helper/modal';
import { Textarea } from '../../../utils/Constant';

const CheckoutForm = () => {
  const Token = JSON.parse(localStorage.getItem("login")!);
  const dispatch = useAppDispatch();
  const { cart } = useAppSelector((state) => state.cartData);
  const clearPanier = () => dispatch(clearCart());
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isOpenClients, setIsOpenClients] = useState<boolean>(false);
  const navigate = useNavigate();
  const [data, setData] = useState({
    fullname: '',
    phone: '',
    email: '',
    adresse: '',
    description: ''
  });
  const [erreur, setErreur] = useState({
    fullname: '',
    phone: '',
    email: '',
    adresse: '',
    description: '',

  });
  const clearDataForm = () => {
    setData({
      fullname: '',
      phone: '',
      email: '',
      description: '',
      adresse: '',
    });
    setErreur({
      fullname: '',
      phone: '',
      email: '',
      adresse: '',
      description: '',
    });
  }
  const changeHandler = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setData((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };
  const handleSubmitData = (e: React.FormEvent) => {
    e.preventDefault();

    axios.post(`${URL_API}/vente/create`, { ...data, cart }, {
      headers: {
        Authorization: `Bearer ${Token}`
      }
    }).then(response => {

      if (response.status === 200) {
        toast.success(response.data.message);
        clearDataForm();
        clearPanier();
        navigate(`/vente-facture/${response.data.vente}`)

      }


    }).catch(error => {
      console.log(error);
      if (error.status == 405) {
        toast.info("Oups !! Erreur de validation des données");
        setErreur(error.response.data.message);
      }
    })
  }
  return (
    <Form onSubmit={handleSubmitData}>
      <Row>
        <Col sm="12">
          <FormGroup>
            <Label for="inputEmail4">Nom & Prénoms</Label>
            <Input id="inputEmail4"
              type="text"
              placeholder="Entrer le nom complet"
              name='fullname'
              value={data.fullname}
              onChange={changeHandler} />
            {erreur.fullname && (<span className="text-danger">{erreur.fullname}</span>)}
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col sm="6">
          <FormGroup>
            <Label for="inputEmail5">Téléphone</Label>
            <Input id="inputEmail5"
              type="number"
              placeholder="Entrer le telephone du client"
              name='phone'
              value={data.phone}
              onChange={changeHandler} />
            {erreur.phone && (<span className="text-danger">{erreur.phone}</span>)}
          </FormGroup>
        </Col>
        <Col sm="6">
          <FormGroup>
            <Label for="inputAddress5">Adesse</Label>
            <Input id="inputAddress5"
              type="text"
              placeholder="Entrer l'adresse du client"
              name='adresse'
              value={data.adresse}
              onChange={changeHandler} />
            {erreur.adresse && (<span className="text-danger">{erreur.adresse}</span>)}
          </FormGroup>
        </Col>
        <Col sm='12'>
          <FormGroup>
            <Label for="inputAddress6">Description</Label>
            <Input type="textarea" className='form-input' name='description' id="inputAddress6" placeholder="Laisser un description ou un message a la vente" value={data.description} onChange={changeHandler} />
            {erreur.description && (<span className="text-danger">{erreur.description}</span>)}
          </FormGroup>
        </Col>
      </Row>
      
      <div className="text-center">
        <Btn type={'submit'} className='btn btn-primary' > Valider la commande </Btn>
        
        <Btn type={'button'} className='btn btn-dark mx-4 text-end' onClick={ () => setIsOpen(true)} >Approvisionner un PDV</Btn>
        <Btn type={'button'} className='btn btn-success text-end' onClick={ () => setIsOpenClients(true)} >Affecter a un client</Btn>
      </div>

      <DispatchementDeProquit isOpen={isOpen} toggle={() => setIsOpen(!isOpen)} />
      <AffecterUneCommadeAUnClient isOpen={isOpenClients} toggle={() => setIsOpenClients(!isOpenClients)} />
        {/* {
          DispatchementDeProquit({
            isOpen: isOpen,
            toggle: setIsOpen(!isOpen)
          })
        } */}
    </Form>
  )
}

export default CheckoutForm